import { DataSource } from "../../Data/DataSource";
import { PartialNullable } from "../../Extensions";
import { Property, PropertyBoolean } from "../../RadObject";
import { ComboBox } from "./ComboBox";
import { IPropertyEditorComboBox, PropertyEditorComboBox, PropertyEditorComboBoxPropertyValues } from "./PropertyEditorComboBox";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorComboBoxYesNoPropertyValues =
    PropertyEditorComboBoxPropertyValues
    & {
        value: boolean;
    };

export type PropertyEditorComboBoxYesNoProperties = {
    [name in keyof PropertyEditorComboBoxYesNoPropertyValues]: Property<PropertyEditorComboBoxYesNoPropertyValues[name]>
};

export interface IPropertyEditorComboBoxYesNo extends IPropertyEditorComboBox, PropertyEditorComboBoxYesNoProperties
{
}

export class PropertyEditorComboBoxYesNo extends PropertyEditorComboBox implements IPropertyEditorComboBoxYesNo
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorComboBoxYesNo";
    public static override className = "PropertyEditorComboBoxYesNo";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorComboBoxYesNoPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new ComboBox({ listDataSource: new DataSource({ data: [{ value: false, description: "No" }, { value: true, description: "Yes" }] }) }),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Overrides

    protected override __initializeProperties(propertyValues: PropertyEditorComboBoxYesNoPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.value = new PropertyBoolean(this, propertyValues.value, this._valueChanged);
    }

    // #endregion

    // #endregion
}
